document.addEventListener("DOMContentLoaded", function () {
  function initOurProductsSlider() {
    if (typeof Swiper === "undefined") {
      setTimeout(initOurProductsSlider, 300); // Retry after delay if Swiper not loaded yet
      return;
    }

    new Swiper(".our-products-swiper", {
      slidesPerView: 3,
      spaceBetween: 30,
      loop: true,
      grabCursor: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        0: { slidesPerView: 1 },
        768: { slidesPerView: 2 },
        1200: { slidesPerView: 3 },
      },
    });
  }

  initOurProductsSlider();
});
